import * as React from 'react';
import { withRouter } from 'react-router';
import { breadcrumbs } from '@inqool/uas-web-core/es/utils';
import Dictionary from '@inqool/uas-web-core/es/components/app/Dictionary';
import { compose, setDisplayName, onlyUpdateForKeys, withProps } from 'recompose';

import { withClassname } from '@components/hoc/withClassname';
import { DayplansFormSingle } from './DayplansFormSingle';
import { withAdditionalProps } from '@components/hoc/withAdditionalProps';
import { withColumns } from '@components/hoc/withColumns';
import { Agenda } from '@modules/columnSettings/_columnSettingsEnums';
import { ColumnManager } from '@modules/columnSettings/ColumnManager';

export const dayplansUrl = '/metropolis/api/hr/workplan/day-plan';
export const dayplansLabel = 'Personalistika - denní plánování';
export const dayplansPath = '/hr/dayplans/items';
export const dayplansGridName = 'DayplansGrid';
export const DayplansGridSingle = compose(
  withRouter,
  setDisplayName(dayplansGridName),
  onlyUpdateForKeys(['url', 'location']),
  breadcrumbs([{ label: dayplansLabel }]),
  withColumns(Agenda.DAYPLANS),
  withProps(({ columns }) => ({
    name: dayplansGridName,
    url: dayplansUrl,
    Form: DayplansFormSingle,
    dialog: false,
    gridProps: {
      columns,
      filterRow: true,
      showCheckboxes: true,
      deleting: true,
      filtering: true,
      locale: 'cz',
      adding: false,
      version: 7,
      ActionBar: () => <ColumnManager agenda={Agenda.DAYPLANS} />
    }
  })),
  withAdditionalProps,
  withClassname({ className: 'mp-grid' })
)(Dictionary);



// WEBPACK FOOTER //
// ./src/modules/hr-dayplans/DayplansGridSingle.tsx